import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TechSpecsSection } from './components/TechSpecsSection';
import { ComparisonTableSection } from './components/ComparisonTableSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { SecondaryServicesSection } from './components/SecondaryServicesSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background font-sans antialiased" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <TechSpecsSection data-id="element-7" />
        <ComparisonTableSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <ServiceAreaSection data-id="element-10" />
        <WhyChooseUsSection data-id="element-11" />
        <SecondaryServicesSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <CTASection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}